import { apiGet, apiPut } from "./http";
import type { TenantPlan } from "./types";

export interface PlanTemplateDto {
  plan: TenantPlan;
  label: string;
  priceAnnual: number;
  maxMembers: number;
  maxAdmins: number;
  storageMb: number;
  features: string[];
}

export interface PatchPlanTemplateBody {
  label?: string;
  priceAnnual?: number;
  maxMembers?: number;
  maxAdmins?: number;
  storageMb?: number;
  features?: string[];
}

export function fetchPlanTemplates() {
  return apiGet<PlanTemplateDto[]>("/api/platform/plan-templates");
}

export function putPlanTemplate(planKey: TenantPlan, body: PatchPlanTemplateBody) {
  return apiPut<PlanTemplateDto>(`/api/platform/plan-templates/${planKey}`, body);
}
